const doc = [({"zh_cn":({"buttonBookingActivity":({"cancelBookingPlan":"取消此预订", "cancelBookingRoom":"取消此体验的预订"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;